import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

const RenderMathOrText = ({ html }) => {
  if (!html) return null;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const renderNode = (node, index) => {
    if (node.nodeType === 3) {
      const text = node.textContent;

      // Block math $$...$$
      const blockMatch = text.match(/\$\$(.+?)\$\$/gs);
      if (blockMatch) {
        const parts = text.split(/\$\$(.+?)\$\$/s);
        return parts.map((part, i) => {
          if (i % 2 === 1) return <BlockMath key={i} math={part} />;
          return <span key={i}>{part}</span>;
        });
      }

      // Inline math $...$
      const inlineMatch = text.match(/\$(.+?)\$/g);
      if (inlineMatch) {
        const parts = text.split(/\$(.+?)\$/);
        return parts.map((part, i) => {
          if (i % 2 === 1) return <InlineMath key={i} math={part} />;
          return <span key={i}>{part}</span>;
        });
      }

      return <span key={index}>{text}</span>;
    }

    if (node.nodeType === 1) {
      const children = Array.from(node.childNodes).map(renderNode);
      switch (node.tagName.toLowerCase()) {
        case 'strong': return <strong key={index}>{children}</strong>;
        case 'em': return <em key={index}>{children}</em>;
        case 'p': return <p key={index}>{children}</p>;
        case 'br': return <br key={index} />;
        default: return <span key={index}>{children}</span>;
      }
    }

    return null;
  };

  return <>{Array.from(doc.body.childNodes).map(renderNode)}</>;
};

export default RenderMathOrText;
